import React, { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import isEmpty from 'lodash/isEmpty';

import {
  crmGridSetPage,
  crmGridSetPageSize,
  useGrid,
} from '@crm-framework/grid';

import {
  getNotificationData,
  getNotMarkedAsReadSelectedIds,
} from './selectors';
import { notificationsActions } from './NotificationsStore';
import { NOTIFICATIONS_GRID_NAME } from './consts';
import { NotificationGrid, NotificationEmptyState } from './components';
import { INotificationGridItem } from './components/notification-grid';

export const NotificationGridComponent: React.FC = () => {
  const dispatch = useDispatch();

  const { items, page, totalCount, pageSize } = useGrid<INotificationGridItem>(
    NOTIFICATIONS_GRID_NAME
  );

  const { isLoading, selectedIds } = useSelector(getNotificationData);

  const notMarkedAsReadSelectedIds = useSelector(getNotMarkedAsReadSelectedIds);

  const onChangePage = useCallback(
    (newPage) => {
      if (page !== newPage) {
        dispatch(crmGridSetPage(NOTIFICATIONS_GRID_NAME, newPage));
        dispatch(notificationsActions.refresh());
      }
    },
    [dispatch, page]
  );

  const onChangePageSize = useCallback(
    (newPage, newPageSize) => {
      if (page !== newPage) {
        dispatch(crmGridSetPage(NOTIFICATIONS_GRID_NAME, newPage));
      }

      if (pageSize !== newPageSize) {
        dispatch(crmGridSetPageSize(NOTIFICATIONS_GRID_NAME, newPageSize));
        dispatch(notificationsActions.refresh());
      }
    },
    [dispatch, page, pageSize]
  );

  const onMarkAsRead = useCallback(() => {
    dispatch(
      notificationsActions.markAsRead({ ids: notMarkedAsReadSelectedIds })
    );
  }, [dispatch, notMarkedAsReadSelectedIds]);

  const onDelete = useCallback(() => {
    dispatch(notificationsActions.delete({ ids: selectedIds }));
  }, [dispatch, selectedIds]);

  return isEmpty(items) ? (
    <NotificationEmptyState isLoading={isLoading} />
  ) : (
    <NotificationGrid
      isLoading={isLoading}
      items={items}
      selectedIds={selectedIds}
      notMarkedAsReadSelectedIds={notMarkedAsReadSelectedIds}
      page={page}
      pageSize={pageSize}
      totalCount={totalCount}
      onChangePage={onChangePage}
      onChangePageSize={onChangePageSize}
      onDelete={onDelete}
      onMarkAsRead={onMarkAsRead}
    />
  );
};
